export class ArrayHelper {
  /**
   * includesAndBetween
   *
   */
  static includesAndBetween(array: any, searchValue: any): boolean {
    for (const i of array) {
      const isIncluded = Array.isArray(i)
        ? searchValue >= i[0] && searchValue <= i[1]
        : i === searchValue;
      if (isIncluded) {
        return true;
      }
    }

    return false;
  }
}
